export default "__VITE_ASSET__0ea1f158__"